import {Navigate, Route, Routes} from "react-router-dom";
import {SubmissionPage} from "./content/submission/SubmissionPage";
import {FormSessionPage} from "./content/session/FormSessionPage";
import {PersonPage} from "./content/person/PersonPage";
import UserRoleResolver from "./content/user/UserRoleResolver";
import {Content} from "./content/Content";
import {UserRoleType} from "./client/user/User";
import {ProfilePage} from "./content/profile/ProfilePage";
import ProtectedRoute from "./util/router/ProtectedRoute";
import {DashboardPage} from "./content/dashboard/DashboardPage";
import {SubmissionAuthorizationInitPage} from "./content/submission/authorization/SubmissionAuthorizationInitPage";
import {SubmissionAuthorizationResultPage} from "./content/submission/authorization/SubmissionAuthorizationResultPage";
import {
    DigitalActionAuthorizationMockPage
} from "./content/submission/authorization/DigitalActionAuthorizationMockPage";
import {
    DigitalActionAuthorizationStartupOutageMockPage
} from "./content/submission/authorization/DigitalActionAuthorizationStartupOutageMockPage";
import {EnvConfiguration} from "./EnvConfig";
import {useRef} from "react";
import {
    SubmissionAuthorizationCompletionPage
} from "./content/submission/authorization/SubmissionAuthorizationCompletionPage";
import {UserPage} from "./content/user/UserPage";
import {MessagePage} from "./content/message/MessagePage";
import {MessageStatePage} from "./content/message-state/MessageStatePage";
import {FormSessionOpenerPage} from "./content/session/opener/FormSessionOpenerPage";

const ADMIN_SUBMISSIONS_PATH = "administracni-prehled-podani";
export const ADMIN_SUBMISSIONS = `/${ADMIN_SUBMISSIONS_PATH}`;
const ADMIN_PERSON_OVERVIEW_PATH = "prehled-osob";
export const ADMIN_PERSON_OVERVIEW = `/${ADMIN_PERSON_OVERVIEW_PATH}`;
const ADMIN_USER_OVERVIEW_PATH = "prehled-uzivatelu";
export const ADMIN_USER_OVERVIEW = `/${ADMIN_USER_OVERVIEW_PATH}`;
const DASHBOARD_PATH = "nastenka";
export const DASHBOARD = `/${DASHBOARD_PATH}`;
const FORM_SESSIONS_PATH = "pristupy";
export const FORM_SESSIONS = `/${FORM_SESSIONS_PATH}`;
const FORM_OPENER_PATH = "form";
export const FORM_OPENER = `/${FORM_OPENER_PATH}`;
const ISDS_MESSAGE_OVERVIEW_PATH = "isds-zpravy";
export const ISDS_MESSAGE_OVERVIEW = `/${ISDS_MESSAGE_OVERVIEW_PATH}`;
const ISDS_MESSAGE_STATE_OVERVIEW_PATH = "isds-stavy-zprav";
export const ISDS_MESSAGE_STATE_OVERVIEW = `/${ISDS_MESSAGE_STATE_OVERVIEW_PATH}`;
const PROFILE_PATH = "profil";
export const PROFILE = `/${PROFILE_PATH}`;
const SUBMISSIONS_PATH = "podani";
export const SUBMISSIONS = `/${SUBMISSIONS_PATH}`;
const SUBMISSION_AUTHORIZATION_INIT_PATH = `${SUBMISSIONS_PATH}/:submissionId/autorizace`;
export const SUBMISSION_AUTHORIZATION_INIT = `/${SUBMISSION_AUTHORIZATION_INIT_PATH}`;
const DIGITAL_ACTION_AUTH_MOCK_PATH = `${SUBMISSIONS_PATH}/:submissionId/mock-digitalniho-ukonu/:digitalActionId`;
export const DIGITAL_ACTION_AUTH_MOCK = `/${DIGITAL_ACTION_AUTH_MOCK_PATH}`;
const DIGITAL_ACTION_AUTH_STARTUP_OUTAGE_MOCK_PATH = "mock-vypadek-startu-autorizace";
export const DIGITAL_ACTION_AUTH_STARTUP_OUTAGE_MOCK = `/${DIGITAL_ACTION_AUTH_STARTUP_OUTAGE_MOCK_PATH}`;
const SUBMISSION_AUTHORIZATION_COMPLETION_PATH = `${SUBMISSIONS_PATH}/dokonceni-autorizace`;
export const SUBMISSION_AUTHORIZATION_COMPLETION = `/${SUBMISSION_AUTHORIZATION_COMPLETION_PATH}`;
const SUBMISSION_AUTHORIZATION_RESULT_PATH = `${SUBMISSIONS_PATH}/:submissionId/vysledek-autorizace`;
export const SUBMISSION_AUTHORIZATION_RESULT = `/${SUBMISSION_AUTHORIZATION_RESULT_PATH}`;


export interface AppRoutesProps {
    userRoles: UserRoleType[];
}

export default function AppRoutes({userRoles}: Readonly<AppRoutesProps>) {
    var config = useRef(EnvConfiguration.getConfig());

    return (
        <Routes>
            <Route index element={<Navigate to={DASHBOARD} replace/>}/>
            <Route path={"/"} element={<Content/>}>
                <Route path={DASHBOARD_PATH} element={<DashboardPage/>}/>
                <Route path={FORM_OPENER_PATH} element={<FormSessionOpenerPage/>}/>
                <Route path={PROFILE_PATH} element={<ProfilePage/>}/>
                <Route element={<ProtectedRoute isAllowed={UserRoleResolver.isAtLeastOperator(userRoles)}
                                                redirectPath={DASHBOARD}/>}>
                    <Route element={<ProtectedRoute isAllowed={UserRoleResolver.isAdministrator(userRoles)} redirectPath={DASHBOARD}/>}>
                        <Route path={SUBMISSIONS_PATH} element={<SubmissionPage isAdminOverview={false}/>}/>
                        <Route path={FORM_SESSIONS_PATH} element={<FormSessionPage/>}/>
                        <Route path={ADMIN_PERSON_OVERVIEW_PATH} element={<PersonPage/>}/>
                        <Route path={ADMIN_USER_OVERVIEW_PATH} element={<UserPage/>}/>
                        <Route path={ISDS_MESSAGE_OVERVIEW_PATH} element={<MessagePage/>}/>
                        <Route path={ISDS_MESSAGE_STATE_OVERVIEW} element={<MessageStatePage/>}/>
                    </Route>
                    <Route path={ADMIN_SUBMISSIONS} element={<SubmissionPage isAdminOverview={true}/>}/>
                </Route>
                <Route path={SUBMISSION_AUTHORIZATION_INIT_PATH} element={<SubmissionAuthorizationInitPage />} />
                {config.current.digitalActionMockEnabled &&
                    <Route path={DIGITAL_ACTION_AUTH_MOCK_PATH} element={<DigitalActionAuthorizationMockPage />} />
                }
                {config.current.digitalActionMockEnabled &&
                    <Route path={DIGITAL_ACTION_AUTH_STARTUP_OUTAGE_MOCK_PATH} element={<DigitalActionAuthorizationStartupOutageMockPage />} />
                }
                <Route path={SUBMISSION_AUTHORIZATION_COMPLETION_PATH} element={<SubmissionAuthorizationCompletionPage />} />
                <Route path={SUBMISSION_AUTHORIZATION_RESULT_PATH} element={<SubmissionAuthorizationResultPage />} />
            </Route>
            <Route path={"*"} element={<Navigate to={DASHBOARD} replace/>}/>
        </Routes>
    );
}
